module.exports = __webpack_public_path__ + "static/media/gym.d2f962a5.jpg";